export default __webpack_public_path__ + "df8eda896ef71c78c80c98eb842b8924.png";